<template>
  <div class="common-header" :class="{ 'fd-hide': isMobile, 'qq-style': isQQ }">
    <div class="header-logo" @click="toGo">
      <img src="@imgs/logo.png" alt="logo" />
    </div>
    <HeaderMenu />
    <HeaderAccount />
  </div>
</template>
<script type="text/ecmascript-6">
import HeaderMenu from './components/Menu'
import HeaderAccount from './components/Account'
import { judgeIsMobile, getBrowser } from '@/utils'
export default {
  name: 'CommonHeader',
  data() {
    return {
      isMobile: judgeIsMobile(),
      isQQ: getBrowser() === 'QQ浏览器'
    }
  },
  components: {
    HeaderMenu,
    HeaderAccount
  },
  methods:{
    toGo(){
        let a = document.createElement('a')
        a.href = window.PROJECT_CONFIG.BASE_URL + '/index.jhtml'
        a.click()
    }
  }
}
</script>

<style lang="scss">
.header-logo {
  padding-bottom: 7px;
  cursor: pointer;
}
.common-header {
  display: flex;
  top: 0;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  font-size: 16px;
  padding: 0 30px;
  cursor: default;
  box-shadow: 0 5px 16px 0 rgba(3, 58, 138, 0.08);
  z-index: 100;
  position: relative;
  background-color: #fff;
  &.qq-style {
    flex-shrink: 0;
  }
}
</style>
